
export default {
    // Reemplaza 'TU_API_KEY_AQUI' por tu API Key real de https://www.api2pdf.com/
    apiKey: '2c24ce54-294e-4801-9dfc-f65da2c3bc25',
    apiUrlPdf: 'https://api-pdf-app.dylo-microservice.com/pdf',

    // Función para detectar el entorno automáticamente basado en el dominio
    getEnvironment() {
        if (typeof window !== 'undefined') {
            const host = window.location.host;
            if (host.includes('localhost') || host.includes('127.0.0.1')) {
                return 'development';
            } else if (host.includes('marbel-prod.iteracrea.com') || host.includes('marbel-dev.iteracrea.com') || host.includes('mb-front-9wwke') || host.includes('marbel-pop')) {
                return 'production';
            }
        }
        return 'production'; // default
    },

    // Configuración de entorno: detecta automáticamente o fallback a 'production'
    get environment() {
        return this.getEnvironment();
    },

    // Configuración de logos según el entorno
    logos: {
        development: '/img/logo-dev.png',  // Logo para desarrollo
        production: '/img/logo.png'        // Logo actual para producción (viene del backend)
    },

    // Función helper para obtener el logo actual
    getCurrentLogo() {
        return this.logos[this.environment] || this.logos.production;
    }
};